import React, { useContext, useState, useEffect } from "react";
import { Link, navigate } from "gatsby";
import { StoreContext } from "../../provider/StoreProvider";
import { LineItem } from "./line-item";
import { formatPrice } from "../../utils/format-price";
import {
  table,
  wrap,
  totals,
  grandTotal,
  collapseColumn,
  labelColumn,
  emptyStateContainer,
  emptyStateHeading,
  emptyStateLink
} from "./cart.module.css";
import Modal from "react-modal";
import styled from "styled-components";
import { GrCart } from "react-icons/gr";
import Underline2 from "../../assets/contact/underline2.png";
import EmptyCart from "../../assets/store/emptycart.svg";
import UnderLine2 from "../../assets/contact/underline2.png";
import "simplebar/dist/simplebar.min.css";
import CloseIcon from "../../assets/store/closeicon.svg";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 3px 20px rgba(0, 0, 0, 0.25)",
    borderRadius: "0px",
    border: "0.5px solid #000000",
    padding: "14px 24px 24px 24px",
    width: "750px",
    height: "auto",
    paddingBottom: "24px",
    maxHeight: "75vh"
  },
  overlay: {
    backgroundColor: "#00000080",
    zIndex: "999999"
  }
};

const customStylesMobile = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 3px 20px rgba(0, 0, 0, 0.25)",
    borderRadius: "0px",
    border: "0.5px solid #000000",
    padding: "24px 24px 32px 24px",
    width: "340px",
    height: "auto",
    paddingBottom: "24px",
    maxHeight: "75vh"
  },
  overlay: {
    backgroundColor: "#00000080",
    zIndex: "999999"
  }
};

// const StyledSimpleBar = styled(SimpleBar)`
//   max-height: 70vh;
//   width: 100%;
//   @media only screen and (max-width: 840px) {
//   }
//   @media only screen and (max-width: 480px) {
//     width: 100%; ;
//   }
// `

const CartContainer = styled.div`
  position: fixed;
  bottom: calc(100vh - 130px);
  right: 30px;
  background-color: white;
  width: 48px;
  height: 48px;
  border: 0.5px solid black;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99999;
  @media only screen and (max-width: 840px) {
    bottom: 30px !important;
  }
`;

const Tr = styled.tr`
  display: contents;
`;

const CartNumber = styled.div`
  position: absolute;
  background: red;
  width: 18px;
  height: 18px;
  display: flex;
  top: -2px;
  right: -2px;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 9px;
  font-size: 11px;
`;

const H1 = styled.h1`
  font-size: 20px;
  margin-bottom: 13px;
`;

export const CheckoutButton = styled.button`
  position: absolute;
  width: 568px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  border-radius: 0px;
  color: white !important;
  font-family: "Futura Condensed";
  font-size: 20px;
  border: 0.5px solid black;
  margin-top: 14px;
  margin-left: auto;
  margin-right: auto;
  bottom: 28px !important;
  margin-left: calc((702px - 568px) / 2) !important;
  :hover {
    color: #ffffff95 !important;
    box-shadow: 4px 4px 7px rgba(225, 225, 225, 0.9);
  }
  @media only screen and (max-width: 840px) {
    margin-left: calc((702px - 70vw) / 2) !important;
    width: 70vw;
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 480px) {
    position: absolute;
    bottom: 28px;
    margin-left: calc((292px - 70vw) / 2) !important;
  }
`;

const ViewMoreProductsButton = styled.button`
  width: 80%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  border-radius: 0px;
  color: white !important;
  font-family: "Futura Condensed";
  font-size: 20px;
  border: 0.5px solid black;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 23px;
  :hover {
    color: #ffffff95 !important;
    box-shadow: 4px 4px 7px rgba(225, 225, 225, 0.9);
  }
  @media only screen and (max-width: 840px) {
    width: 80%;
  }
`;

export const ContactBlockTitle = styled.div`
  font-size: 24px;
  font-weight: 300;
  text-align: left;
  color: black;
  width: fit-content;
  position: relative;
  margin-left: 24px;
  margin-top: 10px;
  margin-bottom: ${props => (props.last ? "16px !important" : "0px")};
  @media (max-width: 850px) {
    font-size: 20px;
    margin: 0px;
  }
`;

export const UnderlineImageContact = styled.img`
  position: absolute;
  bottom: -15px;
  height: auto;
  width: 100%;
  left: 0px;
  @media only screen and (max-width: 480px) {
    width: 100%;
    height: auto;
    bottom: -10px;
  }
`;

const TotalPriceTd = styled.td`
  display: flex;
  padding-top: 16px !important;
  justify-content: flex-end;
  @media only screen and (max-width: 640px) {
    font-size: 20px !important;
    padding-right: 0px !important;
    display: flex;
    justify-content: flex-end;
  }
`;

const TotalPriceSpan = styled.span`
  margin-right: 12px;
  font-size: 20px;
  white-space: nowrap;
`;

const TitleTh = styled.th`
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const TitleTd = styled.th`
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const EmptyCartImage = styled.img`
  width: 100%;
  height: 80px;
  margin-bottom: 48px;
  margin-top: 72px;
`;

const EmptyCartText = styled.p`
  font-size: 20px;
  margin-bottom: 96px;
  width: 100%;
`;

const HeaderBlock = styled.div`
  position: relative;
  height: fit-content;
  width: fit-content;
`;

const UnderlineImage = styled.img`
  position: absolute;
  width: 100%;
  bottom: -7px;
  left: 0px;
  @media only screen and (max-width: 480px) {
    width: 100% !important;
    bottom: -7px;
  }
`;

const Th = styled.th`
  font-size: 20px;
  @media only screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

const CartWrapper = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  width: calc(100% + 8px);
  max-height: calc(75vh - 50px);
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    margin-right: -7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
  }
  @media only screen and (max-width: 840px) {
    max-height: calc(75vh - 50px);
  }
  @media only screen and (max-width: 480px) {
    max-height: calc(70vh - 50px);
  }
`;

export const Cart = () => {
  const { checkout, loading } = useContext(StoreContext);
  const emptyCart = checkout.lineItems.length === 0;
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(true);

  const handleCheckout = () => {
    window.open(checkout.webUrl);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = () => {
    setIsOpen(false);
    navigate("/store");
  };

  const handleResize = () => {
    if (window.innerWidth <= 480) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    if (typeof window !== undefined) {
      window.addEventListener("resize", handleResize);
      handleResize();
    }
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
    return () => {
      window.removeEventListener("resize", appHeight);
    };
  }, []);

  return (
    <>
      <CartContainer>
        <GrCart size={24} onClick={handleModal} />
        {!emptyCart && (
          <CartNumber>
            {checkout.lineItems.reduce((prev, curr) => prev + curr.quantity, 0)}
          </CartNumber>
        )}
      </CartContainer>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={isMobile ? customStylesMobile : customStyles}
        contentLabel="Example Modal"
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            right: "16px",
            padding: "0px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 9999
          }}
        >
          <img src={CloseIcon} size={20} alt="closeicon" />
        </button>
        <CartWrapper className={wrap}>
          {emptyCart ? (
            <div className={emptyStateContainer}>
              <HeaderBlock>
                <H1 className={emptyStateHeading}>
                  YOUR SHOPPING CART IS EMPTY
                </H1>
                <UnderlineImage src={UnderLine2} alt="blackunderline" />
              </HeaderBlock>
              <EmptyCartImage src={EmptyCart} />
              <EmptyCartText>
                Looks like you haven’t found anything yet. We understand that
                sometimes it’s hard to choose
              </EmptyCartText>
              <ViewMoreProductsButton onClick={() => handleNavigate()}>
                View more products
              </ViewMoreProductsButton>
              <Link
                to="/store"
                className={emptyStateLink}
                onClick={() => handleNavigate()}
              >
                Back to home
              </Link>
            </div>
          ) : (
            <>
              <ContactBlockTitle>
                YOUR SHOPPING CART
                <UnderlineImageContact src={Underline2} />
              </ContactBlockTitle>

              <table className={table}>
                <thead>
                  <Tr>
                    <Th></Th>
                    <Th>Item</Th>
                    <TitleTh></TitleTh>
                    <Th>Qty.</Th>
                    <Th>Price</Th>
                  </Tr>
                </thead>
                <tbody style={{ position: "relative" }}>
                  {checkout.lineItems.map(item => (
                    <>
                      <LineItem item={item} key={item.id} />
                    </>
                  ))}
                  <Tr className={grandTotal}>
                    <td className={collapseColumn}></td>
                    <td className={collapseColumn}></td>
                    <TitleTd className={collapseColumn}></TitleTd>
                    <td className={labelColumn}></td>
                    <TotalPriceTd className={totals}>
                      <TotalPriceSpan>Sub total:</TotalPriceSpan>
                      {formatPrice(
                        checkout.totalPriceV2.currencyCode,
                        checkout.totalPriceV2.amount
                      )}
                    </TotalPriceTd>
                  </Tr>
                </tbody>
              </table>
            </>
          )}
        </CartWrapper>
        {!emptyCart && (
          <CheckoutButton onClick={handleCheckout} disabled={loading}>
            Checkout
          </CheckoutButton>
        )}
      </Modal>
    </>
  );
};
